<template>
  <div class="cHeader">
    <div class="imgcontainer">
      <!--传递不同的currentIndex 作为区分不同swiper组件的动态id-->
      <CarouselContainer :slide-list="list" currentIndex="1"></CarouselContainer>
    </div>
    <div class="navit">
      <div
        v-for="(item, index) in navlist"
        :key="index"
        :class="nowitem == item.id ? 'itema item' : 'itemb item'"
        @click="changerouter(item.id,item.srollid)"
      >
        <p>
          <i :class="item.icon"></i>
          {{ item.name }}
        </p>
        <!-- <router-link to="/home" class="item">市局</router-link>
        -->
      </div>
    </div>
  </div>
</template>

<script>
import CarouselContainer from "@/components/swiperItem/index.vue";
export default {
  components: {
    CarouselContainer,
  },
  data() {
    return {
      options: [
        {
          value: "admin",
          label: "admin",
        },
        {
          value: "out",
          label: "退出",
        },
      ],
      user: "admin",
      nowitem: "1",
      ggmc:'',
      ztmc:'',
      spzbmc:'',
      wzmc:'',
      zlmc:'',
      list: [
        // { name: "aaa", img: require("@/assets/images/beijing.png") },
        // {
        //   name: "aaa",
        //   img: require("@/assets/images/Group 278.png"),
        // },
        // {
        //   name: "aaa",
        //   img: require("@/assets/images/beijing.png"),
        // },
      ],
      navlist: [],
    };
  },
  mounted() {
    this.getdata();
    this.getdhmc();
  },
  methods: {
    changerouter(id, srollid) {
      //第一个参数为mutations中定义的函数，第二个参数为该函数的参数
      //如果有多个参数需要传递可以使用对象{}
      if (this.nowitem != id) {
        this.nowitem = id;
        this.$store.commit("SET_scrollId", srollid);
      }
    },
    getdata() {
      // let data = this.$qs.stringify({
      // });
      this.$axios({
        method: "post",
        url: "/admin/kjhqt/banner_list_zs_sy",
        // data: data
      })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res)
            this.list = res.data.data;
          }
        })
        .catch(err => {
           //this.$message.error(err);
        });
    },
    getdhmc() {
      // let data = this.$qs.stringify({
      // });
      this.$axios({
        method: "post",
        url: "/admin/kjhqt/dh_module_list",
        // data: data
      })
        .then(res => {
          if (res.data.code == 200) {
             //console.log(res.data.data[0].module_name)
            //this.list = res.data.data;
            this.ggmc = res.data.data[0].module_name;
            this.ztmc = res.data.data[1].module_name;
            this.spzbmc = res.data.data[2].module_name;
            this.wzmc = res.data.data[3].module_name;
            this.zlmc = res.data.data[4].module_name;
            this.navlist = [
        {
           //name: "公告展示",
          name: this.ggmc,
          url: "",
          icon: "el-icon-message-solid",
          id: "1",
          srollid: "noticecontainer"
        },
        {
          // name: "专题展示",
          name:this.ztmc,
          url: "",
          icon: "el-icon-s-ticket",
          id: "2",
          srollid: "specialcontainer"
        },
        {
          // name: "视频、直播展示",
          name:this.spzbmc,
          url: "",
          icon: "el-icon-video-camera-solid",
          id: "3",
          srollid: "videocontainer"
        },
        {
          // name: "文章展示",
          name:this.wzmc,
          url: "",
          icon: "el-icon-s-order",
          id: "4",
          srollid: "articlecontainer"
        },
        {
          // name: "资料展示",
          name:this.zlmc,
          url: "",
          icon: "el-icon-s-management",
          id: "5",
          srollid: "Informationcontainer"
        },
      ];
          }
        })
        .catch(err => {
           //this.$message.error(err);
        });
    }
  },
};
</script>
<style lang="less" scoped>
.cHeader {
  width: 100%;
  height: auto;
  .imgcontainer {
    width: 100%;
    height: 550px;
    overflow: hidden;
  }
  .navit {
    width: 100%;
    height: 90px;
    background: #4260ff;
    display: flex;
    justify-content: center;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-width: 12%;
      height: 100%;
      cursor: pointer;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 500;
      font-size: 2.2vh;
    }
    .itema {
      color: #1639f3;
      background: linear-gradient(
        180deg,
        #f0f3ff 0%,
        #dfe6ff 48.44%,
        #f0f3ff 99.48%
      );
      box-shadow: 0px 0px 4px rgba(0, 21, 135, 0.18);
    }
    .itemb {
      color: #ffffff;
    }
  }
}
</style>

